import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { login, facebookLogin } from '../../../api/user';
import s from '../../../assets/styles/style.sass';
import s2 from '../login.sass';
import { getAuth, setAuth } from '../../../service/auth';
import {
  setUserInfo,
  setUserName,
  setUserEmail,
  setIsShowLoginModal,
  setIsShowUpdateUserModal,
  setIsShowRegisterModal,
  setUserPassword,
} from '../../../actions/user';

class LoginFacebook extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    isShowLoginModal: PropTypes.bool.isRequired,
    isShowRegisterModal: PropTypes.bool.isRequired,
    isShowUpdateUserModal: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
    setErrorCode: PropTypes.func.isRequired,
    setUserInfo: PropTypes.func.isRequired,
    setUserName: PropTypes.func.isRequired,
    setUserEmail: PropTypes.func.isRequired,
    setIsShowLoginModal: PropTypes.func.isRequired,
    setIsShowUpdateUserModal: PropTypes.func.isRequired,
    setIsShowRegisterModal: PropTypes.func.isRequired,
    setUserPassword: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      isClickLogin: false,
      modelDataDefaultLink: require(`../../../assets/json/default/setting/general/link.json`),
      modelDataLink: require(`../../../assets/json/${lang}/${fileLang}setting/general/link.json`),
    };
    this.login = this.login.bind(this);
    this.onClickFacebookLogin = this.onClickFacebookLogin.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this);
  }

  onClickFacebookLogin() {
    this.facebookLogin.click();
  }

  responseFacebook(callback) {
    if (this.state.isClickLogin) {
      const json = {
        access_token: callback.accessToken,
      };
      facebookLogin(json, this.props.currentLocale)
        .then(response => response.json())
        .then(result => {
          if (result.user.phone_number === null) {
            this.props.setUserEmail(result.user.email);
            this.props.setUserPassword(result.user.session_token);
            this.props.setUserName(result.user.name);

            // close login modal
            if (this.props.isShowLoginModal) {
              this.props.setIsShowLoginModal();
            }

            // close register modal
            if (this.props.isShowRegisterModal) {
              this.props.setIsShowRegisterModal();
            }
            // open update modal
            if (!this.props.isShowUpdateUserModal) {
              this.props.setIsShowUpdateUserModal();
            }
          } else {
            setAuth(
              result.user.id,
              result.user.name,
              result.user.email,
              result.user.session_token,
              result.user.phone_number,
              result.user.verified,
              getAuth().addresses,
              result.user.meta,
              result.user.gender,
              result.user.industry,
              result.user.date_of_birth,
              result.user.profile_photo,
            );
            this.props.setUserInfo(result.user);
            const href =
              typeof this.state.modelDataLink['order'] === 'undefined'
                ? this.state.modelDataDefaultLink['order']
                : this.state.modelDataLink['order'];
            window.location.href = href;
          }
        })
        .catch(error => {
          console.warn('Request failed', error);
        });
    }
  }

  login() {
    const jsonDev = {
      user: {
        email: this.props.email,
        password: this.props.password,
      },
    };
    if (this.props.password.length < 8) {
      return this.props.setErrorCode(1);
    }
    login(jsonDev, this.props.currentLocale)
      .then(response => {
        if (response.status !== 200) {
          return response;
        }
        return response.json();
      })
      .then(result => {
        if (result.status === 401) {
          this.props.setErrorCode(result.status);
        } else {
          this.props.setUserInfo(result.user);
          this.props.toggle();
        }
      })
      .catch(error => {
        console.warn('Request failed', error);
      });
    return '';
  }

  render() {
    return (
      <FacebookLogin
        appId={process.env.FACEBOOK_APP_ID}
        version="6.0"
        fields="name,email,picture"
        scope="public_profile,email"
        disableMobileRedirect={true}
        render={renderProps => (
          <button
            type="submit"
            className={`${s2.button} ${s2.facebook}`}
            onClick={() => {
              this.setState({ isClickLogin: true });
              renderProps.onClick();
            }}
          >
            {this.props.text}
          </button>
        )}
        callback={this.responseFacebook}
      />
    );
  }
}

const mapState = state => ({
  email: state.user.email,
  password: state.user.password,
  currentLocale: state.intl.locale,
  isShowLoginModal: state.user.isShowLoginModal,
  isShowRegisterModal: state.user.isShowRegisterModal,
  isShowUpdateUserModal: state.user.isShowUpdateUserModal,
});

const mapDispatch = {
  setUserInfo,
  setUserName,
  setUserEmail,
  setIsShowLoginModal,
  setIsShowUpdateUserModal,
  setIsShowRegisterModal,
  setUserPassword,
};

export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(LoginFacebook),
);



// WEBPACK FOOTER //
// ./src/components/Login/LoginButton/LoginFacebook.js